import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './locales/i18n';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

window?.electron?.ipcRenderer &&
  window.electron.ipcRenderer.on('main-process-message', (_event, message) => {
    console.log(message);
  });
